import React from 'react';
import { View, Text, StyleSheet, Pressable } from 'react-native';
import { ShopIcon } from '../../resources/svgComponents/ShopIcon';
import LinearGradient from 'react-native-linear-gradient';
import { NavigationProp } from '@react-navigation/native';

type TNectarNookProps = {
  width?: number;
  height?: number;
  backgroundColor?: string;
  backgroundColorIcon?: string;
  borderColor1?: string;
  borderColor2?: string;
  gradientBorderHeight?: number;
  navigation: NavigationProp<any>;
};

export default function NectarNook(props: TNectarNookProps) {
  const {
    width = 141,
    height = 56,
    backgroundColor = '#FEDD88',
    backgroundColorIcon,
    borderColor1 = 'rgba(255, 207, 83, 0.55)',
    borderColor2 = 'rgba(255, 153, 0, 0.55)',
    gradientBorderHeight = 60,
    navigation,
  } = props;
  const onPress = () => {
    navigation.navigate('NectarNook');
  };
  return (
    <LinearGradient
      colors={[borderColor1, borderColor2]}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      style={[styles.gradientBorder, { height: gradientBorderHeight }]}
    >
      <Pressable
        onPress={onPress}
        style={({ pressed }) => [
          pressed && { opacity: 0.8 }, // subtle press feedback
        ]}
      >
        <View style={[styles.card, { backgroundColor, width, height }]}>
          <Text style={styles.label}>Nectar{'\n'}Nook</Text>
          <View>
            <ShopIcon backgroundColor={backgroundColorIcon} />
          </View>
        </View>
      </Pressable>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFE9A0', // top layer
    borderRadius: 16,
    paddingVertical: 5,
    paddingHorizontal: 16,
    justifyContent: 'space-between',
  },
  label: {
    flex: 1,
    fontFamily: 'Secular One',
    fontWeight: '400',
    fontSize: 14,
    color: '#121212',
    marginRight: 10,
  },
  gradientBorder: {
    borderRadius: 16,
    padding: -4,
  },
});
